import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { Route } from 'react-router-dom';
import useApp from '../store/app/appContext';

function PrivateRoute({
  component,
  path
}) {
  
  const {  appState: { user }, getCurrentUser } = useApp();
  const history = useHistory();
  
  async function authenticateMe() {
    await getCurrentUser();
    if (user?.temp_password) history.push('/update-password')
  }

  useEffect(() => {
    authenticateMe();
    
  }, [])

  return (
    <Route component={component} path={path}/>
  )
}

export default PrivateRoute